import { useEffect, useState } from 'react';
import axios from 'axios';
import { Heart, Check, Zap, CloudRain } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TAGS = [
  { id: 'nourishing', label: 'Nourishing', Icon: Heart, tone: 'text-emerald-700 border-emerald-300 bg-emerald-50' },
  { id: 'necessary', label: 'Necessary', Icon: Check, tone: 'text-[#36454F] border-[#36454F]/30 bg-white' },
  { id: 'impulse', label: 'Impulse', Icon: Zap, tone: 'text-amber-700 border-amber-300 bg-amber-50' },
  { id: 'regret', label: 'Regret', Icon: CloudRain, tone: 'text-rose-700 border-rose-300 bg-rose-50' },
];

/**
 * Contentment tag pills for an expense row in the activity feed.
 * Optional 3-second reflection: how did this purchase feel?
 */
export default function ContentmentTags({ expenseId, current, onChange }) {
  const [value, setValue] = useState(current || null);
  const [busy, setBusy] = useState(false);

  // Sync local state when the server-side tag changes (e.g., another household
  // member tags this expense from their device — the 3s poll refetches expenses
  // and this component receives an updated `current` prop).
  useEffect(() => {
    setValue(current || null);
  }, [current]);

  const pick = async (tag) => {
    if (busy) return;
    const next = value === tag ? null : tag;
    setBusy(true);
    setValue(next);
    try {
      await axios.post(`${API_URL}/api/budget/expense/${expenseId}/contentment`, { tag: next || '' });
      if (onChange) onChange(expenseId, next);
    } catch {
      setValue(value); // revert
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid={`contentment-tags-${expenseId}`}>
      {TAGS.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => pick(t.id)}
            disabled={busy}
            className={
              `inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-['Manrope'] font-medium border transition-colors ` +
              (active ? t.tone : 'text-[#36454F]/40 border-[#36454F]/12 bg-transparent hover:bg-[#36454F]/5')
            }
            data-testid={`contentment-${t.id}-${expenseId}`}
          >
            <t.Icon className="w-3 h-3 mr-1" strokeWidth={1.5} />
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
